// extracted by mini-css-extract-plugin
module.exports = {"md":"item-badges_md_1RMz8","ios":"item-badges_ios_hQG-x","container":"item-badges_container_20VID","icons":"item-badges_icons_2uLJm","texts":"item-badges_texts_3K9jA"};